import React from 'react'
import main from './ProfilePic.jpeg'
import './ProfileImg.css'

const ProfileImg = () => {
  return (
    <div className='image'>
        <img src={main} alt='main'></img>
    </div>
  )
}

export default ProfileImg